import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FilterBar from "./components/FilterBar";
import ArchiveTimeline from "./components/ArchiveTimeline";
import Collections from "./components/Collections";
import Ranking from "./components/Ranking";
import Discussion from "./components/Discussion";
import ArchiveIndex from "./components/ArchiveIndex";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <FilterBar />
        <ArchiveTimeline />
        <Collections />
        <Ranking />
        <Discussion />
        <ArchiveIndex />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
    </div>
  );
}